import { AgGridReact } from 'ag-grid-react';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  getAccountList,
  getContactList,
  getGenericMasterFilteredListByKey,
  getGridDataByModuleKey,
  getLeadList,
  getOpportunityList,
} from '../../redux/selector';
import {
  fetchAccountsAndAppendToModule,
  fetchAccountsAndAppendToPriceSheet,
  fetchAccountsAndAppendToProduct,
} from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import apiServices from '../../services/service';
import { DateFormatter } from '../../shared/controls/formatters';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  campaignInputData,
  currencyFormatterByField,
  handleGridSearch,
} from '../../shared/constants';
import CustomPagination from './grid/customPagination';

const ChildAccount = ({
  module,
  localData,
  hasUpdateCampaignPermission,
  handleCallbackGetList,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showPopup3, setShowPopup3] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [filteredCampaignList, setFilteredCampaignList] = useState([]);
  const [editData, setEditData] = useState([]);
  const [deleteData, setDeleteData] = useState([]);
  const gridRef = useRef();
  const localGridRef = useRef();
  const gridData = useSelector(getGridDataByModuleKey('campaignList'));
  const [searchText, setSearchText] = useState(gridData?.inputPayload?.searchText || '');
  const [isFocused, setIsFocused] = useState(false);
  const campaignTotalCount = gridData?.totalCount;
  const [selectedRowsPopup, setSelectedRowsPopup] = useState([]);

  const [localCampaignInputPayload, setLocalCampaignInputPayload] = useState({
    ...campaignInputData,
    module: module,
    moduleId: localData?.id,
  });

  const [totalCount, setTotalCount] = useState(0);
  const gridApiRef = useRef(null);

  let hasInfoCampaignPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.campaignmenu;

  if (userUIControlPermission) {
    hasInfoCampaignPermission = userUIControlPermission?.campaigninfoscreen
      ? userUIControlPermission.campaigninfoscreen.canView
      : true;
  }

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };
  const onSelectionChanged = (event) => {
    setSelectedRows(event.api.getSelectedRows()); // Get all selected rows
  };

  const leadList = useSelector(getLeadList);
  const contactList = useSelector(getContactList);
  const accountList = useSelector(getAccountList);
  const opportunityList = useSelector(getOpportunityList);

  useEffect(() => {
    fetchCampaign();
  }, [localCampaignInputPayload.pageNumber, localCampaignInputPayload.pageSize, localData?.id]);

  const [campaignListAll, setCampaignListAll] = useState(null);

  const fetchCampaign = async () => {
    // if (!localData?.id) return;
    if (searchText) {
      localCampaignInputPayload.searchText = searchText;
    } else {
      localCampaignInputPayload.searchText = null;
    }
    gridApiRef.current?.showLoadingOverlay();
    setLoading(true);
    setSelectedRows([]);
    try {
      const res = await apiServices.getAccountList(localCampaignInputPayload);
      const campaigns = res.data.account || [];

      setCampaignListAll(campaigns);
      setTotalCount(res.data.totalCount || 0);

      if (campaigns.length === 0) {
        gridApiRef.current?.showNoRowsOverlay();
      } else {
        gridApiRef.current?.hideOverlay();
      }
    } catch (error) {
      console.error('Error fetching campaigns', error);
      gridApiRef.current?.showNoRowsOverlay();
    } finally {
      setLoading(false);
      setSelectedRows([]);
    }
  };

  const clearSearch = async () => {
    setSearchText('');

    const payload = {
      ...localCampaignInputPayload,
      pageNumber: 1,
      searchText: '',
    };

    try {
      gridApiRef.current?.showLoadingOverlay(); // ✅ Show loading before fetch
      setLoading(true);
      const res = await apiServices.getAccountList(payload);
      const campaigns = res.data.account || [];

      setCampaignListAll(campaigns);
      setTotalCount(res.data.totalCount || 0);

      if (campaigns.length === 0) {
        gridApiRef.current?.showNoRowsOverlay();
      } else {
        gridApiRef.current?.hideOverlay();
      }
    } catch (error) {
      console.error('Search Clear Error', error);
      gridApiRef.current?.showNoRowsOverlay();
    } finally {
      setLoading(false);
    }
  };

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        {
          statusPanel: () => (
            <CustomPagination
              inputPayload={localCampaignInputPayload}
              setInputPayload={setLocalCampaignInputPayload}
              totalCount={totalCount}
            />
          ),
          align: 'center',
        },
        { statusPanel: 'agSelectedRowCountComponent' },
      ],
    };
  }, [localCampaignInputPayload, totalCount, localData?.id]);

  const memberStatus = useSelector(getGenericMasterFilteredListByKey('MemberStatusCrm'));

  const campaignColumnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerName: '',
      maxWidth: 50,
      suppressSizeToFit: true,
    },
    {
      headerName: 'Account Name',
      field: 'name',
      //   cellRenderer: (params) => {
      //     if (!params.value) return null; // Handle empty or null values
      //     //   return hasInfoAccountPermission ? (
      //    return <Link
      //       to={`/accounts/viewAccount?id=${params.data.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
      //       state={params.data}
      //       style={{ fontWeight: "600" }}
      //     >
      //       {params.value}
      //     </Link>;
      //     //   ) : (
      //     //     <span style={{ fontWeight: "600" }}>{params.value}</span>
      //     //   );
      //   },
      filter: 'agTextColumnFilter',
      // filterParams: commonTextFilterParams,
      minWidth: 180,
    },
    {
      headerName: 'Phone',
      field: 'phone',
      filter: 'agTextColumnFilter',
      // filterParams: commonTextFilterParams
    },
    {
      headerName: 'Alternate Phone',
      field: 'alternatePhone',
      filter: 'agTextColumnFilter',
      // filterParams: commonTextFilterParams
    },
    {
      headerName: 'Website',
      field: 'website',
      filter: 'agTextColumnFilter',
      cellRenderer: (params) => {
        if (!params.value) return null;

        // Ensure URL has protocol for the link
        const url = params.value.startsWith('http') ? params.value : `https://${params.value}`;
        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {params.value}
          </a>
        );
      },
      // filterParams: commonTextFilterParams
    },
    {
      headerName: 'Account Owner',
      field: 'owner',
      filter: 'agSetColumnFilter',
      // filterParams: filterParams(owner?.map((item) => item.display_name))
    },
    {
      headerName: 'Account Type',
      field: 'accountType',
      filter: 'agSetColumnFilter',
      // filterParams: filterParams(accountType?.map((item) => item.displayName)),
      suppressColumnsToolPanel: true,
    },
    {
      headerName: 'Industry',
      field: 'industry',
      filter: 'agSetColumnFilter',
      // filterParams: filterParams(industryList?.map((item) => item.displayName))
    },
    {
      headerName: 'Annual Revenue',
      field: 'annualRevenue',
      filter: 'agNumberColumnFilter',
      //   filterParams: commonTextFilterParams,
      valueFormatter: currencyFormatterByField('annualRevenue'),
    },
  ];

  const localCampaignColumnDefs = [
    {
      headerName: 'Actions',
      cellRenderer: (params) => {
        const paramsValue = { ...params.data };
        return (
          <div className="action-menu">
            {/* {hasUpdateCampaignPermission && ( */}
            <>
              {/* <img
                  src="/assets/images/edit.png"
                  className="action-img1"
                  onClick={() => handleClickEdit(paramsValue)}
                  alt="Edit Contact"
                  title="Edit Contact"
                ></img> */}
              <img
                src="/assets/images/trash.png"
                onClick={() => openPopup3(paramsValue)}
                alt="Delete Contact"
                title="Delete Contact"
                width="12px"
              ></img>
            </>
            {/* )} */}
          </div>
        );
      },
      maxWidth: 120,
      sortable: false,
      filter: false,
      pinned: 'left',
    },
    {
      headerName: 'Account Name',
      field: 'accountName',
      //   cellRenderer: (params) => {
      //     if (!params.value) return null; // Handle empty or null values
      //     //   return hasInfoAccountPermission ? (
      //    return <Link
      //       to={`/accounts/viewAccount?id=${params.data.id}&pageNo=${gridData?.inputPayload?.pageNumber}`}
      //       state={params.data}
      //       style={{ fontWeight: "600" }}
      //     >
      //       {params.value}
      //     </Link>;
      //     //   ) : (
      //     //     <span style={{ fontWeight: "600" }}>{params.value}</span>
      //     //   );
      //   },
      filter: 'agTextColumnFilter',
      // filterParams: commonTextFilterParams,
      minWidth: 180,
    },
    {
      headerName: 'Phone',
      field: 'phone',
      filter: 'agTextColumnFilter',
      // filterParams: commonTextFilterParams
    },
    {
      headerName: 'Website',
      field: 'website',
      filter: 'agTextColumnFilter',
      cellRenderer: (params) => {
        if (!params.value) return null;

        // Ensure URL has protocol for the link
        const url = params.value.startsWith('http') ? params.value : `https://${params.value}`;
        return (
          <a href={url} target="_blank" rel="noopener noreferrer">
            {params.value}
          </a>
        );
      },
      // filterParams: commonTextFilterParams
    },
    // {
    //   headerName: "Account Owner",
    //   field: "owner",
    //   filter: "agSetColumnFilter",
    //   // filterParams: filterParams(owner?.map((item) => item.display_name))
    // },
    {
      headerName: 'Account Type',
      field: 'accountType',
      filter: 'agSetColumnFilter',
      // filterParams: filterParams(accountType?.map((item) => item.displayName)),
      suppressColumnsToolPanel: true,
    },
    {
      headerName: 'Industry',
      field: 'industry',
      filter: 'agSetColumnFilter',
      // filterParams: filterParams(industryList?.map((item) => item.displayName))
    },
    // {
    //   headerName: "PriceSheet Name",
    //   field: "priceSheetName",
    //   filter: "agNumberColumnFilter",
    // },
    {
      headerName: 'Annual Revenue',
      field: 'annualRevenue',
      filter: 'agNumberColumnFilter',
      //   filterParams: commonTextFilterParams,
      valueFormatter: currencyFormatterByField('annualRevenue'),
    },
  ];

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const onSearch = (searchValue) => {
    handleGridSearch({
      searchValue,
      apiMethod: apiServices.getAccountList,
      gridApiRef,
      inputPayload: localCampaignInputPayload,
      setData: setCampaignListAll,
      setTotalCount,
      setLoading,
    });
  };

  const onFilterTextBoxChangedLocal = useCallback(() => {
    localGridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmedText = searchText.trim();
      if (trimmedText) {
        onSearch(trimmedText);
      } else {
        clearSearch(); // <--- this ensures it resets with empty searchText
      }
    }
  };

  const viewCampaign = (params) => {
    alert(`Viewing campaign: ${params.data.campaignName}`);
  };

  const editCampaign = (params) => {
    alert(`Editing campaign: ${params.data.campaignName}`);
  };

  const deleteCampaign = (params) => {
    alert(`Deleting campaign: ${params.data.campaignName}`);
  };

  const frameworkComponents = {
    checkboxRenderer: (props) => {
      const handleChange = (e) => {
        const isSelected = props.node.isSelected();
        props.node.setSelected(!isSelected); // Toggle the selection state of the row
      };

      return <input type="checkbox" checked={props.node.isSelected()} onChange={handleChange} />;
    },
  };

  const handleOpen = () => {
    setIsOpen(true);
    fetchCampaign();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const openPopup2 = () => {
    setShowPopup2(true);
  };

  const closePopup2 = () => {
    setShowPopup2(false);
  };
  // Function to close the third popup
  const closePopup3 = () => {
    setShowPopup3(false);
  };

  // Function to open the third popup
  const openPopup3 = (data) => {
    setShowPopup3(true);
    setDeleteData(data);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'memberStatusId') {
      setFormData({
        ...formData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    }
  };

  //   useEffect(() => {
  //     const plannedOption = memberStatus?.find(
  //       (option) => option.displayName === "Planned"
  //     );

  //     if (plannedOption) {
  //       setSelectedOptions((prevState) => ({
  //         ...prevState,
  //         memberStatusId: plannedOption.id,
  //       }));

  //       setFormData((prevState) => ({
  //         ...prevState,
  //         memberStatus: plannedOption.id,
  //         memberStatusId: plannedOption.displayName,
  //       }));
  //     }
  //   }, [memberStatus, showPopup2]);

  const handleSubmit = async (formData) => {
    setLoading(true);
    // const selectedIds = selectedRowsPopup.map((row) => row.id);
    const selectedIds = selectedRows.map((row) => row.id).join(',');
    // if (formData.type === "edit") {
    //   const data = {
    //     ...formData,
    //     moduleId: formData.id,
    //     campaignId: localData.id,
    //     module: "Lead",
    //   };

    //   await apiServices
    //     .updateCampaignByModule(data)
    //     .then((response) => {
    //       if (response.status === 200) {
    //         setShowPopup2(false);

    //         toast.success("Lead Updated Successfully!", {
    //           position: "top-right",
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Error updating leads:", error);
    //       toast.error("Failed to update leads.", { position: "top-right" });
    //     });
    // } else {
    if (module === 'Product') {
      const data = {
        productId: localData?.id,
        accountId: selectedIds, // or other form fields if needed
      };

      await apiServices
        .accountProductAssociation(data)
        .then((response) => {
          if (response.status === 200) {
            setSelectedRows([]);
            handleClose();
            dispatch(
              fetchAccountsAndAppendToProduct({
                moduleName: 'Product',
                id: localData?.id,
              })
            );
            toast.success('Account Added to Product Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error adding account to product:', error);
          toast.error('Failed to add account to product.', {
            position: 'top-right',
          });
        });
    } else {
      const data = {
        ...formData,
        accountId: selectedIds,
        priceSheetId: localData?.id,
      };

      await apiServices
        .accountPriceSheetAssociation(data)
        .then((response) => {
          if (response.status === 200) {
            setSelectedRows([]);
            handleClose();
            dispatch(
              fetchAccountsAndAppendToPriceSheet({
                moduleName: 'PriceSheet',
                id: localData?.id,
              })
            );
            toast.success('Account Added to PriceSheet Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error adding account:', error);
          toast.error('Failed to add account.', {
            position: 'top-right',
          });
        });
    }
    // }

    // }

    setLoading(false);
    setFormData([]);
  };

  const handleClickDeleteCampaign = (paramsValue) => {
    setLoading(true);

    if (module === 'Product') {
      const data = {
        id: [paramsValue.id],
      };

      apiServices
        .deleteAccountFromProduct(data)
        .then((response) => {
          if (response.status === 200) {
            setShowPopup3(false);
            dispatch(
              fetchAccountsAndAppendToProduct({
                moduleName: 'Product',
                id: localData?.id,
              })
            );
            setLoading(false);
            toast.success('Account Unassigned from Product Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error while unassigning account from product:', error);
          setLoading(false);
        });
    } else {
      const data = {
        id: [paramsValue.id],
      };

      apiServices
        .deleteAccountFromPriceSheet(data)
        .then((response) => {
          if (response.status === 200) {
            setShowPopup3(false);
            dispatch(
              fetchAccountsAndAppendToPriceSheet({
                moduleName: 'PriceSheet',
                id: localData?.id,
              })
            );
            setLoading(false);
            toast.success('Account Unassigned Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error while deleting account:', error);
          setLoading(false);
        });
    }
  };

  const handleClickEdit = (data) => {
    setShowPopup2(true);
    setEditData({
      ...data,
      type: 'edit',
    });
  };

  const showPopupVisibility = () => {
    setShowPopup3(false); // Reset to default page on close
  };

  return (
    <>
      <div className="row" id="campainview">
        <div className="col-12 col-sm-12 col-md-12">
          <div className="infoBox">
            <div className="addlead-header">
              <label htmlFor="" className="flex-div align-items-center">
                <img className="me-2" src="../assets/images/emailIcon.svg" alt="" />
                Accounts({localData?.accountAssociations?.length})
              </label>
              {/* {hasUpdateCampaignPermission && localData?.email && !localData?.emailOptOut &&( */}
              <button type="button" className="btn btn-outline-primary attBtn" onClick={handleOpen}>
                Add Account
              </button>
              {/* )} */}
            </div>
            <div className="leadcontent" style={{ pointerEvents: 'unset' }}>
              <>
                <div className="row">
                  <div className="col-12 col-md-12">
                    <div className="heading_item" style={{ marginBottom: '1rem' }}>
                      <input
                        className="form-control"
                        id="filter-text-box"
                        type="Text"
                        placeholder="Search..."
                        onInput={onFilterTextBoxChangedLocal}
                      />
                    </div>
                    <div className="cutome_ag_theme" id="withFilter">
                      <div
                        className="ag-theme-balham tbl_height"
                        style={{
                          width: '100%',
                          minHeight: `85px`,
                          maxHeight: `calc(100vh - 400px)`,
                          overflow: 'auto',
                        }}
                      >
                        <AgGridReact
                          rowData={localData?.accountAssociations}
                          columnDefs={localCampaignColumnDefs}
                          suppressRowClickSelection={true}
                          defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            resizable: true,
                          }}
                          rowSelection="multiple"
                          sideBar={sideBar}
                          alwaysShowVerticalScroll={true}
                          ref={localGridRef}
                          domLayout="autoHeight"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </div>

            {/* Modal structure Add To Campaigns */}
            {/* Popup */}
            {isOpen && (
              <div id="genricPopup">
                <div className="popup-backdrop">
                  <div className="popup fullWidthPopup">
                    {/* Popup Header */}
                    {/* {loading && <Loader/>} */}
                    <div className="popup-header">
                      <h4 className="popup-title">Add Account to product : {localData?.name}</h4>
                      <button className="custom-btn-close" onClick={handleClose}></button>
                    </div>
                    {/* Popup Body */}
                    <div className="popup-body">
                      <div className="popupbody_header">
                        <div className="hd_leftview">
                          <div className="heading_item" id="contct_search">
                            <div className="search-container">
                              <input
                                type="text"
                                id="filter-text-box"
                                className={`form-control${searchText ? ' focused' : ''}`}
                                placeholder="Search..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyDown={handleKeyDown}
                              />

                              {searchText && (
                                <span className="clear-btn" onClick={clearSearch}>
                                  &times;
                                </span>
                              )}
                              {/* <i className="icon_tt"></i> */}
                              <button
                                className="contactsearch"
                                type="button"
                                onClick={() => onSearch(searchText)}
                                onFocus={() => setIsFocused(true)}
                                onBlur={() => setIsFocused(false)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <circle cx="11" cy="11" r="8"></circle>
                                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="hd_rightview" id="update_campaign">
                          <div className="flx_heding view_fnt">
                            <label>
                              Total Records: <span>{totalCount}</span>
                            </label>
                          </div>
                          <span className="separator"></span>

                          <div className="flx_heding">
                            <button
                              className="add-btn"
                              type="button"
                              onClick={() => handleSubmit(formData)}
                              disabled={selectedRows.length === 0 || loading}
                            >
                              {' '}
                              {selectedRows.length > 0 && loading && (
                                <>
                                  {' '}
                                  <div
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                  ></div>
                                </>
                              )}
                              {selectedRows.length > 0 && loading ? 'Loading...' : `Add to Product`}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="cutome_ag_theme" style={{ marginTop: '1rem' }}>
                        <div
                          className="ag-theme-balham tbl_height"
                          style={{
                            width: '100%',
                            height: `calc(100vh - 300px)`,
                            overflow: 'auto',
                          }}
                        >
                          <AgGridReact
                            rowData={campaignListAll}
                            columnDefs={campaignColumnDefs}
                            suppressRowClickSelection={true}
                            defaultColDef={{
                              flex: 1,
                              minWidth: 100,
                              resizable: true,
                            }}
                            rowSelection="multiple"
                            onSelectionChanged={onSelectionChanged}
                            ref={gridRef}
                            onGridReady={onGridReady}
                            statusBar={statusBar}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {showPopup2 && (
              <div id="genricPopup">
                <div className="popup-backdrop">
                  <div className="popup" style={{ maxWidth: '576px' }}>
                    {/* Popup Header */}
                    <div className="popup-header">
                      <h4 className="popup-title">Update Campaign Member Status</h4>
                      <button className="custom-btn-close" onClick={closePopup2}></button>
                    </div>

                    {/* Popup Body */}
                    <div className="popup-body" style={{ color: '#000', zIndex: '1050' }}>
                      <div className="row">
                        <div className="col-12 col-md-12">
                          <div className="input-container">
                            <>
                              <label htmlFor="memberStatusId">Member Status</label>
                              <Select
                                value={selectedOptions.memberStatusId}
                                placeholder={editData.memberStatus || 'Select Status'}
                                onChange={(selectedOption) =>
                                  handleChange(selectedOption, 'memberStatusId')
                                }
                                options={memberStatus?.map((data) => ({
                                  value: data.id,
                                  label: data.displayName,
                                }))}
                                menuPortalTarget={document.body}
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: '100%',
                                    zIndex: '9999',
                                  }),
                                  control: (base, state) => ({
                                    ...base,
                                    borderRadius: '5px',
                                    border: state.isFocused
                                      ? '2px solid #365397'
                                      : '1px solid #ccc',
                                    boxShadow: state.isFocused ? '0 0 5px #365397' : 'none', // Focus shadow
                                    transition: 'border-color 0.3s, box-shadow 0.3s',
                                  }),
                                  menu: (base) => ({
                                    ...base,
                                    zIndex: '99999', // Dropdown z-index
                                    maxHeight: '150px', // Limit dropdown height
                                    overflowY: 'auto', // Scroll if items exceed height
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: '99999', // Rendered dropdown above everything
                                  }),
                                  option: (base, state) => ({
                                    ...base,
                                    backgroundColor: state.isFocused
                                      ? '#365397' // Hover background
                                      : state.isSelected
                                        ? 'rgba(54, 83, 151, 0.2)' // Selected background
                                        : '#fff', // Default background
                                    color: state.isFocused || state.isSelected ? '#fff' : '#000', // Text color
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s, color 0.3s',
                                  }),
                                  singleValue: (base) => ({
                                    ...base,
                                    padding: '5px',
                                    borderRadius: '3px',
                                  }),
                                }}
                              />
                            </>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Popup Footer */}
                    <div className="popup-footer">
                      <button className="btn btn-outline-primary" onClick={closePopup2}>
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          handleSubmit({
                            ...formData,
                            id: editData.id,
                            type: 'edit',
                          })
                        }
                      >
                        Save
                      </button>

                      {/* Popup 3 Overlay */}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {showPopup3 && (
              <div id="genricPopup">
                <div className="popup-backdrop">
                  <div className="popup">
                    <div className="popup-header">
                      <h2>Confirmation</h2>
                      <button
                        type="button"
                        className="custom-btn-close"
                        aria-label="Close"
                        onClick={showPopupVisibility}
                      ></button>
                    </div>
                    {/* Popup Body */}
                    <div className="popup-body">
                      <div className="row">
                        <div className="col-12 col-md-12">
                          <div className="unassign-txt">
                            <p>
                              Unassign {deleteData.accountName} from {localData?.name}?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Popup Footer */}
                    <div className="popup-footer">
                      <button className="btn btn-outline-primary" onClick={closePopup3}>
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() => handleClickDeleteCampaign(deleteData)}
                        disabled={loading}
                      >
                        {loading && (
                          <div
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></div>
                        )}
                        {loading ? 'Loading...' : 'Unassign'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChildAccount;
